import { SummaryModel } from '../../../../../common/entity/summary.model';
import { PermissionsModel } from '../../../../../common/entity/permissions.model';
import { PlainDtoModel } from '../../../../../common/entity/dto/plain/plainDto.model';

export class WorkflowTaskDefinitionModel implements PlainDtoModel {
    permissions: PermissionsModel;
    name: string;
    label: string;
    id: number;
}
